import React from 'react';
import { connect } from 'react-redux';
import Paper from '@material-ui/core/Paper';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import Collapse from '@material-ui/core/Collapse';
import Chip from '@material-ui/core/Chip';
import { ScrollTabPanel } from '../Reports/index.js';
import { setCommonParam, showToast } from 'actions/admin/auth.js';
import Home from '@material-ui/icons/Home';
import {
  fetchActivitiesByFilterService,
  fetchActivitiesModulesService,
  fetchRecentActivitiesService,
  fetchVoiceCallsService,
  sendVoiceOrActivityService,
  updateAnnouncementActivityService,
} from 'actions/admin/activities.js';
import { convertModuleToName, getGlobalSchoolUtils } from 'utils/commonFunc.js';
import ActivityList from './ActivityList.js';
import { Label, Pagination, PaginationItem, PaginationLink, Input, FormGroup } from 'reactstrap';
import moment from 'moment';
import { Row, Col } from 'reactstrap';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import NewActivityFormModal from './NewActivityFormModal.jsx';
import RecordVoiceOverIcon from '@material-ui/icons/RecordVoiceOver';
import Page from '../Common/Pagination.jsx';
import CommonTooltip from '../Common/CommonTooltip.jsx';
import { CommonLoader } from '../Common/Loader.jsx';
import { store } from 'index.js';
import { Search } from '@material-ui/icons';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import IconButton from '@material-ui/core/IconButton';
import CustomButton from 'components/CustomButton.jsx';
import colors from 'config/colors.js';

export const statusList = [
  { label: 'Pending', value: 'PENDING' },
  { label: 'In progress', value: 'INPROGRESS' },
  { label: 'Completed', value: 'COMPLETED' },
  { label: 'Rejected', value: 'REJECTED' },
  { label: 'Cancelled', value: 'CANCELED' },
  { label: 'Hold', value: 'HOLD' },
];

const tabList = [
  { tabIndex: 0, tabTitle: 'Activities', query: 'activities', icon: <Home /> },
  { tabIndex: 1, tabTitle: 'Voice Messages & Calls', query: 'voice-messages-and-calls', icon: <RecordVoiceOverIcon /> },
];

const defaultFilterData = {
  moduleName: 'STUDENT_MODULE',
  fromUserName: '',
  changesFor: '',
  startDateTime: moment(new Date()).subtract(1, 'M').format('YYYY-MM-DD 00:01'),
  endDateTime: moment(new Date()).format('YYYY-MM-DD 23:59'),
  page: 1,
  limit: 10,
};

let timer;
// No BE cap exists on this endpoint's limit - this is just how far a quick filter looks
// when it needs more than the current "Show" page to find matches.
const QUICK_FILTER_FETCH_LIMIT = 500;
const initialState = {
  activeTab: 0,
  recentActivitiesFetching: false,
  limit: 10,
  filterActivitiesFetching: false,
  filterData: defaultFilterData,
  isActivityModalOpen: false,
  voiceCallsFetching: false,
  pageParams: {
    page: 1,
    size: 20,
  },
  callStatus: 'PENDING',
  // Search is a collapsible panel over the Activities tab, not its own tab - these two
  // flags track whether it's open, and whether a search is currently driving the list
  // (vs. showing plain recent activity).
  searchExpanded: false,
  isSearchApplied: false,
  // Quick filter tags (module-wise). Client-side only: the filter-by-module API only
  // accepts a single moduleName, but these chips support multi-select, so matching
  // is done here against whatever list (recent or search results) is already loaded.
  quickFilterModules: [],
  // Limit in effect just before a quick filter auto-expanded it to QUICK_FILTER_FETCH_LIMIT,
  // so it can be restored once every quick filter tag is cleared.
  preQuickFilterLimit: null,
};
class SchoolActivities extends React.Component {
  state = initialState;

  quickFilterScrollRef = React.createRef();

  scrollQuickFilters = direction => {
    this.quickFilterScrollRef.current?.scrollBy({ left: direction * 220, behavior: 'smooth' });
  };

  isLoading = (name, value) => {
    this.setState(prevState => ({ ...prevState, [name]: value }));
  };

  showWarning = (message, type) => {
    store.dispatch(showToast(message, type));
  };

  componentDidMount() {
    const { search = null } = this.props?.location || {};
    if (search) {
      const cTab = tabList.find(dto => search.includes(dto.query));
      if (cTab) {
        this.toggleActivityTab(null, cTab.tabIndex);
      } else {
        this.toggleActivityTab(null, 0);
      }
    } else {
      this.toggleActivityTab(null, 0);
    }
    this.fetchActivitiesModules();
    this.fetchRecentActivities();
  }

  fetchActivitiesModules = async () => {
    const { loggedUserId, loggedUserToken } = this.props;
    const globalSchool = getGlobalSchoolUtils();
    await this.props.fetchActivitiesModules({
      schoolId: globalSchool.schoolId,
      loggedUserId,
      token: loggedUserToken,
    });
  };

  fetchRecentActivities = async (limit = this.state.limit) => {
    this.isLoading('recentActivitiesFetching', true);
    const { loggedUserId, loggedUserToken } = this.props;
    const globalSchool = getGlobalSchoolUtils();
    await this.props.fetchRecentActivities({
      schoolId: globalSchool.schoolId,
      loggedUserId,
      token: loggedUserToken,
      limit,
    });
    this.isLoading('recentActivitiesFetching', false);
  };

  clean(obj) {
    for (let propName in obj) {
      if (obj[propName] === null || obj[propName] === undefined || obj[propName] === '') {
        delete obj[propName];
      }
    }
    return obj;
  }

  fetchFilterActivities = async (filterData = this.state.filterData) => {
    this.isLoading('filterActivitiesFetching', true);
    const { loggedUserId, loggedUserToken } = this.props;
    const globalSchool = getGlobalSchoolUtils();
    const passData = this.clean({ ...filterData });
    await this.props.fetchFilterActivities({
      schoolId: globalSchool.schoolId,
      loggedUserId,
      token: loggedUserToken,
      filterData: passData,
    });
    this.isLoading('filterActivitiesFetching', false);
  };

  toggleActivityTab = (event, tabIndex) => {
    const { actvitiesActiveTab } = this.props;
    if (tabIndex !== undefined && actvitiesActiveTab !== tabIndex) {
      setCommonParam('actvitiesActiveTab', tabIndex);
      if (tabIndex === 1) this.fetchVoiceCalls();
      const cTab = tabList.find(dto => dto.tabIndex === tabIndex);
      if (cTab) {
        this.props.history.push(`${this.props.location.pathname}?${cTab.query}`);
      }
    }
  };

  handleLimitChange = event => {
    const limit = event.target.value;
    this.setState(prevState => ({ ...prevState, limit }));
    this.fetchRecentActivities(limit);
  };

  updateFilterData = (name, value) => {
    this.setState(
      {
        ...this.state,
        filterData: {
          ...this.state.filterData,
          [name]: value,
        },
        ...(name === 'limit' && { limit: value }),
      },
      () => {
        name === 'limit' && this.fetchFilterActivities();
      }
    );
  };

  toggleSearch = () => {
    this.setState(prevState => ({ ...prevState, searchExpanded: !prevState.searchExpanded }));
  };

  applySearch = () => {
    // Panel visibility is only ever driven by the toggle button (toggleSearch) - applying a
    // search must not also collapse it, otherwise the filter panel vanishes right when the
    // user acts on it, instead of staying visible as confirmation the search is in progress.
    this.setState({ isSearchApplied: true }, () => this.fetchFilterActivities());
  };

  clearSearch = () => {
    clearTimeout(timer);
    this.setState({ filterData: defaultFilterData, isSearchApplied: false, searchExpanded: false });
  };

  removeFilterChip = key => {
    const newFilterData = { ...this.state.filterData };
    if (key === 'dateRange') {
      newFilterData.startDateTime = defaultFilterData.startDateTime;
      newFilterData.endDateTime = defaultFilterData.endDateTime;
    } else {
      newFilterData[key] = defaultFilterData[key];
    }
    this.setState({ filterData: newFilterData }, () => this.fetchFilterActivities());
  };

  activeFilterChips = () => {
    const { filterData } = this.state;
    const chips = [];
    if (filterData.moduleName && filterData.moduleName !== defaultFilterData.moduleName) {
      chips.push({ key: 'moduleName', label: `Module: ${convertModuleToName(filterData.moduleName)}` });
    }
    if (filterData.changesFor) {
      chips.push({ key: 'changesFor', label: `For: ${filterData.changesFor}` });
    }
    if (filterData.fromUserName) {
      chips.push({ key: 'fromUserName', label: `By: ${filterData.fromUserName}` });
    }
    if (
      filterData.startDateTime !== defaultFilterData.startDateTime ||
      filterData.endDateTime !== defaultFilterData.endDateTime
    ) {
      chips.push({
        key: 'dateRange',
        label: `${moment(filterData.startDateTime).format('DD MMM')} - ${moment(filterData.endDateTime).format(
          'DD MMM'
        )}`,
      });
    }
    return chips;
  };

  toggleQuickFilterModule = moduleName => {
    const wasActive = this.state.quickFilterModules.length > 0;
    const isSelected = this.state.quickFilterModules.includes(moduleName);
    const quickFilterModules = isSelected
      ? this.state.quickFilterModules.filter(m => m !== moduleName)
      : [...this.state.quickFilterModules, moduleName];
    const nowActive = quickFilterModules.length > 0;
    this.setState({ quickFilterModules }, () => {
      if (!wasActive && nowActive) this.expandLimitForQuickFilter();
      else if (wasActive && !nowActive) this.restoreLimitAfterQuickFilter();
    });
  };

  clearQuickFilterModules = () => {
    const wasActive = this.state.quickFilterModules.length > 0;
    this.setState({ quickFilterModules: [] }, () => {
      if (wasActive) this.restoreLimitAfterQuickFilter();
    });
  };

  // A quick filter can only match what's already been fetched, so the first time one is
  // turned on, pull a much bigger page (see QUICK_FILTER_FETCH_LIMIT) instead of leaving it
  // scoped to whatever the "Show" page size happens to be.
  expandLimitForQuickFilter = () => {
    if (this.state.isSearchApplied) {
      this.setState(
        prevState => ({
          preQuickFilterLimit: prevState.filterData.limit,
          filterData: { ...prevState.filterData, limit: QUICK_FILTER_FETCH_LIMIT },
        }),
        () => this.fetchFilterActivities()
      );
    } else {
      this.setState({ preQuickFilterLimit: this.state.limit, limit: QUICK_FILTER_FETCH_LIMIT }, () =>
        this.fetchRecentActivities(QUICK_FILTER_FETCH_LIMIT)
      );
    }
  };

  restoreLimitAfterQuickFilter = () => {
    const restoreLimit = this.state.preQuickFilterLimit || defaultFilterData.limit;
    if (this.state.isSearchApplied) {
      this.setState(
        prevState => ({ filterData: { ...prevState.filterData, limit: restoreLimit } }),
        () => this.fetchFilterActivities()
      );
    } else {
      this.setState({ limit: restoreLimit }, () => this.fetchRecentActivities(restoreLimit));
    }
  };

  openActivityModal = () => {
    this.setState(prevState => ({ ...prevState, isActivityModalOpen: true }));
  };

  formModalClose = () => {
    this.setState(prevState => ({ ...prevState, isActivityModalOpen: false }));
  };

  sendVoice = data => {
    const globalSchool = getGlobalSchoolUtils();
    return this.props.sendVoice({
      schoolId: this.state.schoolId || globalSchool.schoolId,
      token: this.props.loggedUserToken,
      ...data,
    });
  };

  updateActivity = (auditLogId, auditDescription) => {
    const globalSchool = getGlobalSchoolUtils();
    return this.props.updateActivity({
      schoolId: this.state.schoolId || globalSchool.schoolId,
      token: this.props.loggedUserToken,
      auditLogId,
      auditDescription,
    });
  };

  updateSuccess = () => {
    this.formModalClose();
    if (this.state.isSearchApplied) {
      this.fetchFilterActivities();
    } else {
      this.fetchRecentActivities();
    }
  };

  fetchVoiceCalls = async (callStatus = this.state.callStatus) => {
    const globalSchool = getGlobalSchoolUtils();
    this.isLoading('voiceCallsFetching', true);
    await this.props.fetchVoiceCalls({
      schoolId: this.state.schoolId || globalSchool.schoolId,
      token: this.props.loggedUserToken,
      pageParams: this.state.pageParams,
      callStatus,
    });
    this.isLoading('voiceCallsFetching', false);
  };

  fetchPageData = page => {
    if (page !== this.state.pageParams.page) {
      this.setState(
        {
          pageParams: {
            ...this.state.pageParams,
            page,
          },
        },
        () => {
          this.fetchVoiceCalls();
        }
      );
    }
  };

  handleStatusChange = val => {
    this.setState(
      {
        callStatus: val.value,
      },
      () => {
        this.fetchVoiceCalls();
      }
    );
  };

  render() {
    const {
      recentActivitiesFetching,
      limit,
      filterData,
      filterActivitiesFetching,
      isActivityModalOpen,
      voiceCallsFetching,
      callStatus,
      searchExpanded,
      isSearchApplied,
      quickFilterModules,
    } = this.state;
    const { actvitiesActiveTab: activeTab, modules, recentActivities, filterActivities, voiceCallData } = this.props;
    const baseActivities = isSearchApplied ? filterActivities : recentActivities;
    const quickFilteredActivities = quickFilterModules.length
      ? baseActivities?.filter(el => quickFilterModules.includes(el?.moduleName))
      : baseActivities;
    const noDataFound = (
      <div style={{ textAlign: 'center', fontWeight: 'bold', paddingTop: '50px', paddingBottom: '50px' }}>
        No data found.
      </div>
    );

    const customStyles = {
      control: base => ({
        ...base,
        minHeight: 31,
        height: 31,
      }),
      dropdownIndicator: base => ({
        ...base,
        paddingTop: 0,
        paddingBottom: 0,
      }),
      clearIndicator: base => ({
        ...base,
        paddingTop: 0,
        paddingBottom: 0,
      }),
    };

    const filterSection = (
      <Paper variant="outlined" style={{ marginBottom: 12, padding: 12, backgroundColor: '#fafbfc' }}>
        <Row>
          <Col md={4} sm={4} xs={4}>
            <Label>Module</Label>
            <Select
              style={{ paddingLeft: 5 }}
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={filterData?.moduleName ? { label: filterData?.moduleName, value: filterData.moduleName } : null}
              onChange={val => this.updateFilterData('moduleName', val?.value || '')}
              options={modules?.map(el => {
                return {
                  label: el,
                  value: el,
                };
              })}
              isClearable
              styles={customStyles}
            />
          </Col>
          <Col md={4} sm={4} xs={4}>
            <Label htmlFor="">Start date</Label>
            <br />
            <DatePicker
              className="form-control"
              selected={filterData.startDateTime ? new Date(filterData.startDateTime) : null}
              onChange={value =>
                this.updateFilterData('startDateTime', value ? moment(value).format('YYYY-MM-DD hh:mm') : null)
              }
              dateFormat="dd/MM/yyyy h:mm aa"
              showMonthDropdown
              showYearDropdown
              placeholderText="Select date..."
              dropdownMode="select"
              showTimeInput
            />
          </Col>
          <Col md={4} sm={4} xs={4}>
            <Label htmlFor="">End date</Label>
            <br />
            <DatePicker
              className="form-control"
              selected={filterData.endDateTime ? new Date(filterData.endDateTime) : null}
              onChange={value =>
                this.updateFilterData('endDateTime', value ? moment(value).format('YYYY-MM-DD hh:mm') : null)
              }
              dateFormat="dd/MM/yyyy h:mm aa"
              showMonthDropdown
              showYearDropdown
              placeholderText="Select date..."
              dropdownMode="select"
              showTimeInput
            />
          </Col>
        </Row>
        <Row style={{ marginTop: 10 }}>
          <Col md={4} sm={4} xs={4}>
            <Label htmlFor="">Changes for</Label>
            <Input
              type="text"
              name="changesFor"
              onChange={e => this.updateFilterData('changesFor', e.target.value)}
              value={filterData?.changesFor || ''}
              placeholder="Student,Exam,Leaves,etc"
              maxLength="50"
            />
          </Col>
          <Col md={4} sm={4} xs={4}>
            <Label htmlFor="">Updated by</Label>
            <Input
              type="text"
              name="fromUserName"
              onChange={e => this.updateFilterData('fromUserName', e.target.value)}
              value={filterData?.fromUserName || ''}
              placeholder="admin@gmail.com,etc"
              maxLength="50"
            />
          </Col>
          <Col md={4} sm={4} xs={4} style={{ alignSelf: 'flex-end' }}>
            <CustomButton
              size="small"
              type="button"
              variant="contained"
              color="secondary"
              onClick={() => this.applySearch()}
              name={
                <>
                  <Search /> Search
                </>
              }
            />
            <CustomButton
              size="small"
              type="button"
              color="default"
              onClick={() => this.clearSearch()}
              className="ml-2"
              name="Reset"
            />
          </Col>
        </Row>
      </Paper>
    );

    const activitiesTab = (
      <>
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 10 }}>
          <CustomButton
            size="small"
            type="button"
            variant={searchExpanded ? 'contained' : 'outlined'}
            color={isSearchApplied || searchExpanded ? 'secondary' : 'default'}
            onClick={() => this.toggleSearch()}
            name={
              <>
                <Search fontSize="small" style={{ verticalAlign: 'middle' }} />{' '}
                {isSearchApplied ? 'Edit search' : 'Search'}
              </>
            }
          />
        </div>
        <Collapse in={searchExpanded}>
          <div>{filterSection}</div>
        </Collapse>
        {isSearchApplied && !searchExpanded && (
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, alignItems: 'center', marginBottom: 12 }}>
            {this.activeFilterChips().map(chip => (
              <Chip
                key={chip.key}
                label={chip.label}
                size="small"
                onDelete={() => this.removeFilterChip(chip.key)}
                style={{ backgroundColor: '#F5EDFB', color: colors.accent, fontWeight: 'bold' }}
              />
            ))}
            <Chip label="Clear all" size="small" variant="outlined" onClick={() => this.clearSearch()} />
          </div>
        )}
        {!!modules?.length && (
          <div style={{ marginBottom: 12 }}>
            <div style={{ color: '#8b95a1', fontSize: 12, fontWeight: 'bold', marginBottom: 6 }}>Quick filter</div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <IconButton
                size="small"
                onClick={() => this.scrollQuickFilters(-1)}
                aria-label="Scroll quick filters left"
                style={{ flexShrink: 0, padding: 4 }}>
                <ChevronLeft fontSize="small" />
              </IconButton>
              <div
                ref={this.quickFilterScrollRef}
                style={{
                  display: 'flex',
                  flexWrap: 'nowrap',
                  overflowX: 'auto',
                  gap: 6,
                  alignItems: 'center',
                  paddingBottom: 4,
                  scrollBehavior: 'smooth',
                }}>
                {modules.map(moduleName => {
                  const selected = quickFilterModules.includes(moduleName);
                  return (
                    <Chip
                      key={moduleName}
                      label={convertModuleToName(moduleName)}
                      size="small"
                      onClick={() => this.toggleQuickFilterModule(moduleName)}
                      variant="outlined"
                      style={{
                        borderRadius: 6,
                        flexShrink: 0,
                        ...(selected
                          ? {
                              backgroundColor: colors.accent,
                              color: '#fff',
                              fontWeight: 'bold',
                              borderColor: colors.accent,
                            }
                          : {}),
                      }}
                    />
                  );
                })}
                {!!quickFilterModules.length && (
                  <Chip
                    label="Clear"
                    size="small"
                    variant="outlined"
                    onClick={() => this.clearQuickFilterModules()}
                    style={{ borderRadius: 6, flexShrink: 0 }}
                  />
                )}
              </div>
              <IconButton
                size="small"
                onClick={() => this.scrollQuickFilters(1)}
                aria-label="Scroll quick filters right"
                style={{ flexShrink: 0, padding: 4 }}>
                <ChevronRight fontSize="small" />
              </IconButton>
            </div>
          </div>
        )}
        <ActivityList
          recentActivitiesFetching={isSearchApplied ? filterActivitiesFetching : recentActivitiesFetching}
          activities={quickFilteredActivities}
          limit={limit}
          handleLimitChange={
            isSearchApplied ? e => this.updateFilterData('limit', e.target.value) : this.handleLimitChange
          }
          sendVoice={this.sendVoice}
          updateActivity={this.updateActivity}
          updateSuccess={this.updateSuccess}
          showWarning={this.showWarning}
        />
        {isSearchApplied && (
          <div>
            <Pagination aria-label="Page navigation example" style={{ textAlign: 'center', justifyContent: 'center' }}>
              <PaginationItem>
                <PaginationLink
                  href="#"
                  previous
                  onClick={() => filterData?.page > 1 && this.updateFilterData('page', filterData?.page - 1)}
                />
              </PaginationItem>
              <PaginationItem>
                <PaginationLink href="#">{filterData?.page}</PaginationLink>
              </PaginationItem>
              <PaginationItem>
                <PaginationLink
                  href="#"
                  next
                  onClick={() => filterActivities.length >= 10 && this.updateFilterData('page', filterData?.page + 1)}
                />
              </PaginationItem>
            </Pagination>
          </div>
        )}
      </>
    );

    return (
      <div className="content">
        <Paper elevation={3} style={{ minHeight: '425px', backgroundColor: '#F4F6F8' }}>
          <Paper square elevation={3}>
            <Tabs
              value={activeTab}
              onChange={(e, tabIndex) => this.toggleActivityTab(e, tabIndex)}
              indicatorColor=""
              textColor={'inherit'}
              variant="fullWidth"
              scrollButtons="auto"
              aria-label="scrollable force tabs example">
              {tabList.map(item => {
                return (
                  <Tab
                    key={item.tabIndex}
                    icon={item?.icon}
                    label={item.tabTitle}
                    style={{
                      fontWeight: 'bold',
                      color: activeTab === item.tabIndex ? colors.accent : '',
                      borderBottom: activeTab === item.tabIndex ? `3px solid ${colors.accent}` : '',
                    }}
                  />
                );
              })}
            </Tabs>
          </Paper>
          <ScrollTabPanel value={activeTab} index={0} style={{ padding: 10 }}>
            {activitiesTab}
          </ScrollTabPanel>
          <ScrollTabPanel value={activeTab} index={1} style={{ padding: 10 }}>
            <Row>
              <Col md={6} sm={6} xs={6}>
                <FormGroup>
                  <Label htmlFor="">
                    <strong>
                      Filter by status<sup> *</sup>{' '}
                    </strong>
                  </Label>
                  <br />
                  <Select
                    onChange={val => this.handleStatusChange(val)}
                    options={statusList}
                    value={statusList.find(dt => dt.value === callStatus)}
                  />
                </FormGroup>
              </Col>
            </Row>
            {voiceCallsFetching && (
              <div style={{ textAlign: 'center', marginTop: 20 }}>
                <CommonLoader />
              </div>
            )}
            {!voiceCallsFetching && voiceCallData?.content?.length > 0 ? (
              <>
                <Row style={{ paddingLeft: 10, paddingRight: 10 }}>
                  {voiceCallData?.content?.map((el, k) => {
                    return (
                      <Col key={k} md={6} sm={6} xs={6} style={{ padding: 5 }}>
                        <Paper key={k} style={{ padding: '5px' }}>
                          <span
                            style={{
                              paddingLeft: 5,
                              paddingRight: 5,
                              fontWeight: 'bold',
                              float: 'right',
                              backgroundColor: '#ffd783',
                              marginTop: -5,
                              marginRight: -5,
                              borderEndStartRadius: 3,
                            }}>
                            <small>
                              <b>{el?.callStatus}</b>
                            </small>
                          </span>
                          <div style={{ paddingLeft: 10, paddingBottom: 5 }}>
                            <div style={{ marginTop: 10, marginBottom: 10 }}>{el?.title}</div>
                            <div className="card-category">
                              {' '}
                              <audio controls="controls" preload="auto" id="audio_player">
                                <source src={el?.downloadUrl} />
                              </audio>
                            </div>
                            <div className="card-category mb-1" style={{ fontSize: 13 }}>
                              {el.description}
                            </div>
                            <div className="card-category">
                              <small>
                                Sent by{' '}
                                <CommonTooltip content={el?.fromUserName}>
                                  <span>{el?.uploadedBy}</span>
                                </CommonTooltip>
                              </small>
                            </div>
                          </div>
                          <span style={{ float: 'right', marginTop: -20 }}>
                            <small>{moment(el.creationDateTime).format('DD MMM, YYYY hh:mm A')}</small>
                          </span>
                        </Paper>
                      </Col>
                    );
                  })}
                </Row>
                <div>
                  <Page
                    fetchPageData={this.fetchPageData}
                    style={{ marginTop: 15, marginLeft: 0, marginRight: 0 }}
                    {...voiceCallData}
                    isLoading={voiceCallsFetching}
                  />
                </div>
              </>
            ) : (
              !voiceCallsFetching && noDataFound
            )}
          </ScrollTabPanel>
        </Paper>
        <NewActivityFormModal
          isActivityModalOpen={isActivityModalOpen}
          formModalCloseProp={this.formModalClose}
          sendVoice={this.sendVoice}
          updateSuccess={this.updateSuccess}
        />
      </div>
    );
  }
}

export default connect(
  state => ({
    loggedUserToken: state.auth.loggedUserToken,
    loggedUserId: state.auth.loggedUserId,
    loggedUserEmail: state.auth.loggedUserEmail,
    actvitiesActiveTab: state.auth.actvitiesActiveTab,
    modules: state.activities.modules,
    recentActivities: state.activities.recentActivities,
    filterActivities: state.activities.filterActivities,
    voiceCallData: state.activities.voiceCallData,
  }),
  dispatch => ({
    fetchActivitiesModules: data => dispatch(fetchActivitiesModulesService(data)),
    fetchRecentActivities: data => dispatch(fetchRecentActivitiesService(data)),
    fetchFilterActivities: data => dispatch(fetchActivitiesByFilterService(data)),
    sendVoice: data => dispatch(sendVoiceOrActivityService(data)),
    updateActivity: data => dispatch(updateAnnouncementActivityService(data)),
    fetchVoiceCalls: data => dispatch(fetchVoiceCallsService(data)),
  })
)(SchoolActivities);
